import React, { useEffect, useState } from 'react'
import { Cross } from 'components/icons'
import Button from 'components/button'
import { useAuth } from 'hooks/auth'
import { safeLocalStorage } from 'helpers/localStorage'
import { FREE_TRIAL_BANNER_DISMISSED_KEY } from 'app-constants'
const FreeTrial: React.FC = () => {
  const { user } = useAuth()
  const [showBanner, setShowBanner] = useState(() => {
    return safeLocalStorage.getItem(FREE_TRIAL_BANNER_DISMISSED_KEY) !== 'true'
  })

  useEffect(() => {
    if (!showBanner) return
    const id = setTimeout(() => {
      setShowBanner(false)
      safeLocalStorage.setItem(FREE_TRIAL_BANNER_DISMISSED_KEY, 'true')
    }, 120_000)
    return () => clearTimeout(id)
  }, [showBanner])

  const handleClose = () => {
    setShowBanner(false)
    safeLocalStorage.setItem(FREE_TRIAL_BANNER_DISMISSED_KEY, 'true')
  }

  const getFreeTrialDaysRemaining = () => {
    if (user && user.createdAt) {
      const startDateUTC = new Date(user.createdAt + 'Z')
      const endDateUTC = new Date(user.createdAt + 'Z')

      // Calculate end date of trial
      endDateUTC.setDate(startDateUTC.getDate() + 30)
      const todayUTC = new Date(new Date().toISOString().slice(0, 16) + 'Z')
      const diff = endDateUTC.getTime() - todayUTC.getTime()
      const differenceInDays = diff / 86400000 // 1000 * 60 * 60 * 24

      // Return only int part of differenceInDays
      return Math.max(0, Math.trunc(differenceInDays))
    }
  }

  const visible = user && user.isOnFreeTrial && showBanner

  if (!visible) return null

  return (
    // A light wash of the alert yellow under body text, the way the sidebar tints a selected row, so it
    // reads in both themes (solid yellow under white text did not). One line of text, room on the
    // right for the close button; the two stars that sat above and below it are gone.
    <div
      data-testid="free-trial-banner"
      className="absolute rounded transition-all text-center text-body bottom-0 left-0 right-0 ml-auto mr-auto w-fit z-[2000] py-2 pl-5 pr-10 border bg-[color-mix(in_srgb,var(--color-alert)_18%,var(--color-surface))] border-[color-mix(in_srgb,var(--color-alert)_45%,var(--color-surface))]"
    >
      {/* A Button, so it can be reached and pressed from the keyboard. */}
      <Button
        internalType="transparent"
        className="absolute cursor-pointer top-1/2 -translate-y-1/2 right-2 p-0.5 text-inherit"
        onClick={handleClose}
        aria-label="Close banner"
      >
        <Cross className="h-[18px] w-[18px]" />
      </Button>
      <p>
        You have <span className="font-bold">{getFreeTrialDaysRemaining() ?? 0} days left</span> on your paid
        subscription free trial. After that you will only have view and contribute access.
      </p>
    </div>
  )
}

export default FreeTrial
